import { Controller } from "@hotwired/stimulus"

// The contact section's "Saved contact" picker. Picking one copies its
// type, name, brokerage, email and phone into the form's contact fields,
// which staff can still edit. The page carries every saved contact in one
// data attribute ({ id: { agent_name: ... } }), so nothing is fetched.
export default class extends Controller {
  static values = { contacts: Object }

  fill(event) {
    const values = this.contactsValue[event.target.value]
    if (!values) return

    const form = this.element.closest("form")
    Object.entries(values).forEach(([field, value]) => {
      if (field === "contact_type") {
        const radio = form.querySelector(`[name="projection_request[contact_type]"][value="${value}"]`)
        if (radio) radio.checked = true
      } else {
        const input = form.querySelector(`[name="projection_request[${field}]"]`)
        if (!input) return
        input.value = value
        // As if typed, so the phone mask formats the picked number.
        input.dispatchEvent(new Event("input", { bubbles: true }))
      }
    })
  }
}
